import PreferedLocaleLabel from './PreferedLocaleLabel';

export const VEHICLE_STATES = {
  active: 'active',
  not_active: 'not_active',
  removed: 'removed',
  carrier_banned: 'banned',
};

export const DRIVER_STATES = {
  active: 'active',
  not_active: 'not_active',
  removed: 'removed',
  banned: 'banned',
  carrier_banned: 'carrier_banned',
};

export const CARRIER_STATES = {
  active: 'active',
  not_active: 'not_active',
  removed: 'removed',
  banned: 'banned',
};

export const DOCUMENT_STATUS = {
  status_new: 'status_new',
  status_validated: 'status_validated',
  status_not_uploaded: 'status_not_uploaded',
  status_uploading: 'status_uploading',
  status_pending_next_face: 'status_pending_next_face',
  status_close_to_expire: 'status_close_to_expire',
  status_expired: 'status_expired',
  status_invalid: 'status_invalid',
  status_error: 'status_error',
};

export const PREFERRED_LOCALES = [
  {
    label: <PreferedLocaleLabel language="spanish" />,
    value: 'es',
  },
  {
    label: <PreferedLocaleLabel language="english" />,
    value: 'en',
  },
  {
    label: <PreferedLocaleLabel language="french" />,
    value: 'fr',
  },
  {
    label: <PreferedLocaleLabel language="dutch" />,
    value: 'nl',
  },
  {
    label: <PreferedLocaleLabel language="polish" />,
    value: 'pl',
  },
];
